// extracted by mini-css-extract-plugin
module.exports = {"dots":"styles_dots__h9lmX","threedots":"styles_threedots__qSHeE","dotTwo":"styles_dotTwo__lMqZF","dotThree":"styles_dotThree__P90gx"};